import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {
    TextField,
    OutlinedInput,
    InputAdornment,
    IconButton,
    InputLabel,
    FormControl,
    FormHelperText
} from '@material-ui/core';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import _isEqual from "lodash/isEqual";
import InputMask from 'react-input-mask'

import {userRegisterFormChange, resetUserRegisterForm} from '../../vendors/actions/user';
import PasswordInfoWindow from "../../elements/passwordInfoWindow";
import {isMobileBrowser} from "../../vendors/utils/common";


interface OwnProps {
    userRegisterFormChange?: any,
    resetUserRegisterForm?: any
}

interface MainState {
    user: any,
    form: any,
    showPassword: boolean
}

interface ConnectStateProps {
    User: any,
}

interface ConnectDispatchProps {
    userRegisterFormChange?: (data: any) => void;
    UserRegisterForm?: any,
    resetUserRegisterForm?: (data: any) => void
}


type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

const MaskedComponent = (props: any) => {
    const {...other} = props;
    return (
        <InputMask
            {...other}
            mask="(999) 999-9999" maskChar=" "/>
    )
};

class Register extends React.Component<HeaderProps, MainState> {
    state = {
        user: {},
        showPassword: false,
        form: {
            fullName: {
                value: '',
                error: false,
                dirty: false
            },
            firstName: {
                value: '',
                error: false
            },
            lastName: {
                value: '',
                error: false
            },
            email: {
                value: '',
                error: false,
                apiError: false,
                dirty: false
            },
            password: {
                value: '',
                error: false,
                dirty: false,
                errTypes: {
                    u: false,
                    l: false,
                    n: false,
                    min: false
                }
            },
            phone: {
                value: '',
                error: false,
                dirty: false
            }
        }
    };

    static getDerivedStateFromProps(props: any, state: any) {
        const {UserRegisterForm} = props;
        if (UserRegisterForm && (!_isEqual(state.form, UserRegisterForm.data))) {
            return {
                form: UserRegisterForm.data
            };
        }
        return null;
    }

    componentWillUnmount() {
        this.props.resetUserRegisterForm()
    }

    setFullName = (e: any, validate: Boolean = false) => {
        const value = e.target.value;
        this.props.userRegisterFormChange({value, field: 'fullName', validate});
    };

    setEmail = (e: any, validate: Boolean = false) => {
        const value = e.target.value;
        this.props.userRegisterFormChange({value, field: 'email', validate});
    };

    setBusinessName = (e: any) => {
        const value = e.target.value;
        this.props.userRegisterFormChange({value, field: 'businessName'});
    };

    setPassword = (e: any, validate: Boolean = false) => {
        const value = e.target.value;
        this.props.userRegisterFormChange({value, field: 'password', validate});

    };

    setPhone = (e: any, validate: Boolean = false) => {
        let value = e.target.value;
        if (value) {
            value = value.replace(/\D+/g, '');
            if (value) {
                value = parseInt(value);
            }
        }
        this.props.userRegisterFormChange({value, field: 'phone', validate});
    };

    triggerShowPassword = () => {
        const {showPassword} = this.state;
        this.setState({showPassword: !showPassword})
    };


    render() {
        const {form, showPassword} = this.state;
        return (
            <Fragment>
                <form className="w-100">
                    <div className={'text-field-custom-mb'}>
                        <TextField
                            fullWidth
                            error={(!!form?.fullName?.error || !!form?.firstName?.error || !!form?.lastName?.error) && form?.fullName?.dirty}
                            helperText={form?.fullName?.dirty && (form?.fullName?.error || form?.firstName?.error || form?.lastName?.error)}
                            label="Full Name"
                            onChange={this.setFullName}
                            onBlur={(e)=> this.setFullName(e, true)}
                            id="full-name"
                            variant="outlined"
                        />
                    </div>
                    <div className={'text-field-custom-mb'}>
                        <TextField
                            fullWidth
                            onChange={this.setBusinessName}
                            label={(()=> <span>Company Name <i style={{fontWeight: "lighter",fontFamily: 'Roboto'}}>(optional)</i></span>)()}
                            id="business"
                            variant="outlined"
                        />
                    </div>
                    <div className={'text-field-custom-mb'}>
                        <TextField
                            fullWidth
                            error={(!!form?.email?.error || form?.email?.apiError) && form?.email?.dirty}
                            helperText={form?.email?.dirty && (form?.email?.error || form?.email?.apiError)}
                            onChange={this.setEmail}
                            onBlur={(e)=> this.setEmail(e, true)}
                            label="Email"
                            id="email"
                            inputProps={{
                                autoFocus: false
                            }}
                            variant="outlined"
                        />
                    </div>
                    <div className={'text-field-custom-mb'}>
                        <FormControl
                            fullWidth
                            error={!!form?.password?.error && form?.password?.dirty}
                            variant="outlined"
                            onBlur={(e)=> this.setPassword(e, true)}
                            >
                            <InputLabel htmlFor="password">
                                Create Password
                            </InputLabel>
                            {isMobileBrowser() && <PasswordInfoWindow options={{...form?.password?.errTypes}}/>}
                            <OutlinedInput
                                fullWidth
                                value={form.password.value || ''}
                                id="password"
                                type={showPassword ? 'text' : 'password'}
                                onChange={this.setPassword}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={this.triggerShowPassword}
                                            onMouseDown={(e) => e.preventDefault()}
                                            edge="end">
                                            {showPassword ? (
                                                <Visibility/>
                                            ) : (
                                                <VisibilityOff/>
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                labelWidth={110}
                            />
                            {!isMobileBrowser() && <PasswordInfoWindow options={{...form?.password?.errTypes}}/>}
                            {!!form?.password?.error && form?.password?.dirty && <FormHelperText id="standard-weight-helper-text">{form?.password?.error}</FormHelperText>}
                        </FormControl>
                    </div>
                    <div className={'text-field-custom-mb'}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Phone Number"
                            error={!!form?.phone?.error && form?.phone?.dirty}
                            helperText={form?.phone?.dirty && form?.phone?.error ? form?.phone?.error : ''}
                            onChange={this.setPhone}
                            onBlur={(e)=> this.setPhone(e, true)}
                            id="phone"
                            InputProps={{
                                inputComponent: MaskedComponent,
                            }}
                        >
                        </TextField>
                    </div>
                </form>
            </Fragment>
        )
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, UserRegisterForm} = state;
    return {
        User,
        UserRegisterForm
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        userRegisterFormChange: (data: any) => dispatch(userRegisterFormChange(data)),
        resetUserRegisterForm: (data: any) => dispatch(resetUserRegisterForm(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
